import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Img from "gatsby-image";

import WidgetContainer from "components/WidgetContainer/WidgetContainer";
import BusinessForm from "../BusinessForm/BusinessForm";
import GoogleCaptchaBadge from "components/Captcha/Badge";
import phonepeStats from "helpers/constants/phonepeStats";

import "./BusinessFormWidget.css";

const BusinessFormWidget = () => {
    const data = useStaticQuery(
        graphql`
            query BusinessFormWidgetQuery {
                mobileImage: file(
                    relativePath: { eq: "switch-form-mobile-1x.png" }
                ) {
                    childImageSharp {
                        fluid {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }

                desktopImage: file(
                    relativePath: { eq: "switch-form-web-1x.png" }
                ) {
                    childImageSharp {
                        fluid {
                            ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        `
    );
    let sources = [
        {
            ...data.desktopImage.childImageSharp.fluid,
            media: `(min-width: 600px)`,
        },
        {
            ...data.mobileImage.childImageSharp.fluid,
            media: `(max-width: 600px)`,
        },
    ];

    return (
        <WidgetContainer stylesClass="business-form-widget">
            <div className="business-form-widget-container">
                <div className="business-form-widget-container__form">
                    <BusinessForm />
                </div>
                <div className="business-form-widget-container__img-container">
                    <Img
                        fluid={sources}
                        alt="Side graphic - Register on PhonePe"
                        imgStyle={{
                            objectFit: "contain",
                            height: "100%",
                        }}
                    />
                    <h2>
                        Get access to over <br />
                        {phonepeStats.registeredUsers} million PhonePe users.
                        <br />
                        Register Now!
                    </h2>
                    <div className="recaptcha-badge">
                        <GoogleCaptchaBadge />
                    </div>
                </div>
            </div>
        </WidgetContainer>
    );
};

export default BusinessFormWidget;
